import React, { Fragment, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { getPedidoActivo, nuevoPedido } from '../../../actions/pedidos'
import BuscadorExtrusion from './BuscadorExtrusion'
import CarritoExtrusion from './CarritoExtrusion'
import MenuExtrusion from './MenuExtrusion'

const ArticulosExtrusion = () => {
  window.wookie()

  const dispatch = useDispatch()

  const pedido = useSelector(state => state.pedidos.pedido)

  useEffect(() => {
    if (pedido?.id_pedido && pedido?.estado_pedido === 'D') {
      dispatch(nuevoPedido())
      dispatch(getPedidoActivo('', 'S', ''))
    }
  }, [pedido])

  return (
    <Fragment>
      <BuscadorExtrusion />
      <Box className='menu-articulos-extrusion'>
        <Grid
          container
          spacing={2}
          rowSpacing={{ xs: 4, sm: 4 }}>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}>
            <MenuExtrusion />
          </Grid>
          {/* <CarritoExtrusion /> */}
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}>
            <CarritoExtrusion />
          </Grid>
        </Grid>
      </Box>
    </Fragment>
  )
}

export default ArticulosExtrusion
